export default "__VITE_ASSET__DIsIJgRO__"